export default __webpack_public_path__ + "static/media/BL.95747314.svg";